import React, { useState } from 'react'
import 'styles/AddActivityModal.css'
import { useTranslation } from 'react-i18next'
import { getOnChangeFunction } from 'utils'
import ButtonComponent from 'components/common/ButtonComponent'

const AddActivityModal = ({ onClose, onSave }) => {
  const { t } = useTranslation()
  const [formData, setFormData] = useState({
    activityName: '',
    allDevices: false,
    shared: false,
    isFullBlock: false,
    requireScan: true
  })

  const onChange = getOnChangeFunction(setFormData, formData)

  return (
    <div className='add-activity-modal-overlay'>
      <div className='add-activity-modal'>
        <div className='pb-3'>
          <h3 className='text-lg font-semibold text-greenPrimary'>{t('mgmt.activityModal.createTitle')}</h3>
        </div>
        <div className='form-group'>
          <label>{t('mgmt.activityModal.activityName')} *</label>
          <input
            type='text'
            name='activityName'
            value={formData.activityName}
            onChange={onChange}
            required
          />
        </div>
        <div className='checkbox-group'>
          <label>
            <input
              type='checkbox'
              name='allDevices'
              checked={formData.allDevices}
              onChange={onChange}
            />
            {t('mgmt.activityModal.allDevices')}
          </label>
          <label>
            <input
              type='checkbox'
              name='shared'
              checked={formData.shared}
              onChange={onChange}
            />
            {t('mgmt.activityModal.shared')}
          </label>
          <label>
            <input
              type='checkbox'
              name='isFullBlock'
              checked={formData.isFullBlock}
              onChange={onChange}
            />
            {t('mgmt.activityModal.fullBlock')}
          </label>
          <label>
            <input
              type='checkbox'
              name='requireScan'
              checked={formData.requireScan}
              onChange={onChange}
            />
            {t('mgmt.activityModal.requiresScan')}
          </label>
        </div>
        <div className='flex justify-end space-x-4 mt-4'>
          <ButtonComponent onClick={onClose} customColorsStyles='bg-gray-100 text-greenPrimary hover:text-white'>
            {t('mgmt.common.cancel')}
          </ButtonComponent>
          <ButtonComponent onClick={() => onSave(formData)}>
            {t('mgmt.common.save')}
          </ButtonComponent>
        </div>
      </div>
    </div>
  )
}

export default AddActivityModal
